import { Injectable } from '@angular/core';
import { FooterResponse } from './models/footer.response';
import { Footer, FooterAppStore, FooterLink, FooterSocial } from './models/footer.model';

@Injectable({
  providedIn: 'root',
})
export class FooterFactory {
  buildFooter(response: FooterResponse): Footer | null {
    if (response.length === 0) {
      return null;
    }

    const { id, codClient } = response[0];
    return {
      id,
      clientCode: codClient,
      appStores: this.buildAppStores(response),
      links: this.buildLinks(response),
      personalInfo: this.buildPersonalInfo(response),
      social: this.buildSocial(response),
    };
  }

  private buildAppStores(response: FooterResponse): FooterAppStore[] {
    const storeKinds = ['GooglePlay', 'AppStore', 'HuaweiAppGallery', 'Microsoft'];
    const storeImages = {
      GooglePlay: '/assets/app-stores/google.svg',
      AppStore: '/assets/app-stores/apple.svg',
      HuaweiAppGallery: '/assets/app-stores/huawei.svg',
      Microsoft: '/assets/app-stores/microsoft.svg',
    };

    return response
      .filter((footerKind) => storeKinds.includes(footerKind.kind))
      .map<FooterAppStore>((footerKind) => ({
        image: storeImages[footerKind.kind],
        title: footerKind.name,
        url: footerKind.link,
      }));
  }

  private buildLinks(response: FooterResponse): FooterLink[] {
    return response
      .filter((footerKind) => footerKind.kind.includes('generic'))
      .map<FooterLink>((footerKind) => ({
        title: footerKind.name,
        url: footerKind.link,
      }));
  }

  private buildPersonalInfo(response: FooterResponse): string | undefined {
    const info = response.find((footerKind) => footerKind.kind.includes('personalInformation'));

    if (info) {
      return info.link.replace(/<span/g, '<p').replace(/\/span>/g, '/p>');
    }

    return undefined;
  }

  private buildSocial(response: FooterResponse): FooterSocial[] {
    const socialKinds = ['Facebook', 'Twitter', 'Linkedin', 'Instagram', 'Pinterest', 'Youtube', 'Email'];
    const socialIcons = {
      Facebook: 'social_facebook',
      Twitter: 'social_x',
      Linkedin: 'social_linkedin',
      Instagram: 'social_instagram',
      Pinterest: 'social_pinterest',
      Youtube: 'social_youtube',
      Email: 'email',
    };

    return response
      .filter((footerKind) => socialKinds.includes(footerKind.kind))
      .map<FooterSocial>((footerKind) => ({
        icon: socialIcons[footerKind.kind],
        title: footerKind.name,
        url: footerKind.link,
      }));
  }
}
